import React from "react";
import Chart from "react-apexcharts";

const CircularChart = ({ data }) => {
  const options = {
    chart: { type: 'donut' },
    labels: ['Head Count', 'New Joinee', 'On Leave'],
    colors: ['#28a745', '#ffc107', '#dc3545'],
    legend: { position: 'bottom' }
  };

  return <Chart options={options} series={data} type="donut" height={300} />;
};

export default CircularChart;
